<template>
    <header class="mb-4 pb-4 bg-accent shadow-dark">
        <BomVersionBanner class="bg-accent-secondary" @change="navigateTo(localePath('/bom/import'))" />
        <div class="flex items-center justify-end gap-2 h-14 mx-7 md:mx-16 mb-5">
            <HeaderAccountMenu v-if="$viewport.isGreaterOrEquals('md')" />
            <HeaderMobileMenu v-else />
        </div>
        <div class="flex flex-col items-center mx-auto">
            <EnhancedImage
                css-class="mx-auto block"
                :src="logoUrl"
                :lazy-load="false"
                alt="TrustedParts.com"
                multi-resolution
                v-bind="logoProps" />
            <h1 class="text-center font-normal md:leading-9 mb-0 mt-4 md:mt-8 text-lg md:text-3xl text-white">
                {{ $t("Layout.SearchHeader") }}
            </h1>
            <form
                class="mt-4 max-w-screen-md w-full px-6"
                role="search"
                :action="localePath('/search')"
                @submit.prevent>
                <HeaderSearchBox
                    v-if="$viewport.isGreaterOrEquals('md')"
                    :placeholder="$t('Layout.SearchPartNumberDefaultText')"
                    :language="locale"
                    :region="currentRegion.ShortName"
                    :is-home="true" />
                <HeaderMobileSearchBox v-else :language="locale" :region="currentRegion.ShortName" :is-home="true" />
            </form>
            <div class="hidden lg:flex gap-8 text-base my-8">
                <HeaderLanguageMenu />
                <HeaderCurrenciesMenu />
                <HeaderRegionsMenu />
            </div>
            <HeaderTaglines />
        </div>
    </header>
</template>
<script setup>
import { useNuxtApp } from "#app";
const { $viewport } = useNuxtApp();
const { locale } = useI18n();
const config = useRuntimeConfig();
const localePath = useLocalePath();

const cdnUrl = config.public.cdnUrl;
const logoUrl = cdnUrl + "/assets/images/trusted-parts-logo.svg";

const currentRegion = useCurrentRegion();

const logoProps = computed(() =>
    $viewport.isGreaterOrEquals("md") ? { height: "88", width: "600" } : { height: "35", width: "236" }
);
</script>
